import SellerSSR, { getServerSideProps as getServerSidePropsSSR } from "../../components/sellerSSR";
import Seller from "../../components/seller";
import { IS_MOBILE } from "../../data/js/server-constants";

// Export getServerSideProps for SSR (required at page level)
export const getServerSideProps = IS_MOBILE ? undefined : getServerSidePropsSSR;

export default IS_MOBILE ? Seller : SellerSSR;
